export class Program
{
    public id = null;
    public name = '';
    public description = '';
    public active = true;
    public leader: any;
    public category: any;
    public version: number;
    public isTemplate = false;
    public createdBy?: string;
    public createdOn?: Date;
    public lastModifiedBy?: string;
    public lastModifiedOn?: Date;
    public channels?: any;
    public metrics?: any;
    public ruleSetText: string;
    public organization: any;
    public template: any;
    public groups: any[];
}

export class ProgramChannel
{
    public id: number;
    public name: string;
    public version: number;
    public bpmId: string = null;
    public bpmKey: string = null;
    public bpmName: string = null;
    public appId: string = null;
    public channelZip: string = null;
    public modelFileName: string = null;
    public copyChannelId: number = null;
}
